// extracted by mini-css-extract-plugin
export default {"container":"I7e_Qv","more":"dAvbAw"};